import { render } from "./compliance_policies.html?vue&type=template&id=b56c6282&external"
import script from "./compliance_policies.js?vue&type=script&lang=js&external"
export * from "./compliance_policies.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__